module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-Medium.50e0905a.woff2";